import { render, staticRenderFns } from "./WalletDelegationsList.vue?vue&type=template&id=7af11dde&"
import script from "./WalletDelegationsList.vue?vue&type=script&lang=js&"
export * from "./WalletDelegationsList.vue?vue&type=script&lang=js&"
import style0 from "./WalletDelegationsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports